export default __webpack_public_path__ + "static/media/Family.686eb8f4.mp4";